import {
  keyBy,
  flow,
  get,
  mapValues,
  toPairs,
  map,
  mapKeys,
  isObject,
} from 'lodash/fp';
import { createSelector } from 'reselect';

const MIN_VALUE = 1;

const getInputRangeProps = createSelector(get(['options']), (options) =>
  options
    ? {
        minValue: MIN_VALUE,
        maxValue: options.length,
        step: MIN_VALUE,
      }
    : {},
);

const getIndexesByValue = flow(
  get(['options']),
  toPairs,
  map(([index, object]) => ({
    ...object,
    index: Number(index) + 1,
  })),
  keyBy('value'),
  mapValues(get(['index'])),
);

const getValuesByIndex = flow(
  get(['options']),
  map('value'),
  mapKeys((index) => Number(index) + 1),
);

export default {
  indexesByValue: getIndexesByValue,
  valuesByIndex: getValuesByIndex,
  inputRangeProps: getInputRangeProps,
  isRangeMode: flow(get(['input', 'value']), isObject),
};
